import { PiArrowLeftBold, PiArrowRightBold } from "react-icons/pi";

export default function Pagination({ currentPage, totalPages, onPageChange }) {
    return (
        <div className="flex justify-between items-center p-3 sm:p-4 px-4 sm:px-6 text-sm text-gray-900 dark:text-gray-100">
            <div className="flex font-bold">
                <button
                    className="px-2 sm:px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg flex items-center gap-1 sm:gap-2 disabled:cursor-auto disabled:opacity-50 hover:bg-gray-50 dark:hover:bg-gray-700"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    <span><PiArrowLeftBold fontSize={20} /></span>
                    <span className="hidden sm:inline">Previous</span>
                </button>
            </div>
            {/* Mobile: show current/total */}
            <div className="flex sm:hidden items-center gap-2 text-sm font-medium">
                <span>{currentPage}</span>
                <span className="text-gray-400">/</span>
                <span>{totalPages}</span>
            </div>
            {/* Desktop: show page numbers */}
            <div className="hidden sm:flex justify-center">
                <div className="flex items-end gap-2">
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => {
                        if (totalPages <= 10) {
                            return (
                                <>
                                    {num === currentPage && <div className="bg-primary text-black border border-gray-100 dark:border-gray-700 p-2 px-4 rounded-lg font-bold" key={num}>{num}</div>}
                                    {num !== currentPage && <div className="bg-white dark:bg-gray-800 border border-white dark:border-gray-800 p-2 px-4 rounded-lg cursor-pointer hover:border-gray-100 dark:hover:border-gray-600" key={num} onClick={() => onPageChange(num)}>{num}</div>}
                                </>
                            )
                        }
                        if (num === 1 && currentPage - 3 > 1) {
                            return (
                                <>
                                    <div className="bg-white dark:bg-gray-800 border border-white dark:border-gray-800 p-2 px-4 rounded-lg cursor-pointer hover:border-gray-100 dark:hover:border-gray-600" key={num} onClick={() => onPageChange(num)}>{num}</div>
                                    {currentPage - 4 > 1 && <div className="p-2">...</div>}
                                </>
                            )
                        }
                        if (num < 0) {
                            return
                        }
                        if (num > totalPages) {
                            return
                        }
                        if (num === currentPage) {
                            return (
                                <>
                                    {[currentPage - 3, currentPage - 2, currentPage - 1].map(page => {
                                        if (page < 1) {
                                            return
                                        }
                                        if (page > totalPages) {
                                            return
                                        }
                                        return (
                                            <div className="bg-white dark:bg-gray-800 border border-white dark:border-gray-800 p-2 px-4 rounded-lg cursor-pointer hover:border-gray-100 dark:hover:border-gray-600" key={page} onClick={() => onPageChange(page)}>{page}</div>
                                        )
                                    })}
                                    {num === currentPage && <div className="bg-primary text-black border border-gray-100 dark:border-gray-700 p-2 px-4 rounded-lg font-bold" key={num} onClick={() => onPageChange(num)}>{num}</div>}
                                    {[currentPage + 1, currentPage + 2, currentPage + 3].map(page => {
                                        if (page > totalPages) {
                                            return
                                        }
                                        if (page < 0) {
                                            return
                                        }
                                        return (
                                            <div className="bg-white dark:bg-gray-800 border border-white dark:border-gray-800 p-2 px-4 rounded-lg cursor-pointer hover:border-gray-100 dark:hover:border-gray-600" key={page} onClick={() => onPageChange(page)}>{page}</div>
                                        )
                                    })}
                                </>
                            )
                        }
                        if (num === totalPages && currentPage + 3 < totalPages) {
                            return (
                                <>
                                    {currentPage + 4 < totalPages && <div className="p-2">...</div>}
                                    <div className="bg-white dark:bg-gray-800 border border-white dark:border-gray-800 p-2 px-4 rounded-lg cursor-pointer hover:border-gray-100 dark:hover:border-gray-600" key={num} onClick={() => onPageChange(num)}>{num}</div>
                                </>
                            )
                        }
                    })}
                </div>
            </div>
            <div className="flex justify-end font-bold">
                <button
                    className="px-2 sm:px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg flex items-center gap-1 sm:gap-2 disabled:cursor-auto disabled:opacity-50 hover:bg-gray-50 dark:hover:bg-gray-700"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    <span className="hidden sm:inline">Next</span>
                    <PiArrowRightBold fontSize={20} />
                </button>
            </div>
        </div>
    );
};